import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import whatsapp from "../../Images/svg/whatsapp.webp";
import { Link } from "react-router-dom";
import facebook from "../../Images/icons/facebook.png";
import twitter from "../../Images/icons/twitter.png";
import instagram from "../../Images/icons/instagram.png";
import linkedin from "../../Images/icons/linkedin.png";
import youtube from "../../Images/icons/youtube.png";
import logoWhite from "../../Images/logo/isbm-university-white.png";
import EnquiryNow from "./EnquiryNow3";

const Footer = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi"
        );
        setSchools(response.data.data);
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <a href="https://api.whatsapp.com/send/?phone=%2B919373199999&text&type=phone_number&app_absent=0">
        <img alt="whatsapp" id="whatsappp" src={whatsapp} />
      </a>
      <button
        onClick={() => setModalShow(true)}
        className="trigger_popup border-0"
      >
        <span>Enquire Now</span>
      </button>
      <EnquiryNow show={modalShow} onHide={() => setModalShow(false)} />

      <div className="footer-section">
        <Container>
          <Row>
            {/* Column 1: About Us */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">About Us</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/about-us">About ISBM University </Link>
                </li>
                <li>
                  <Link to="/vision-mission">Vision and Mission</Link>
                </li>
                <li>
                  <Link to="/honorable-visitor">Hon'ble Visitor</Link>
                </li>
                <li>
                  <Link to="/honorable-patron">Hon'ble Patron</Link>
                </li>
                <li>
                  <Link to="/honorable-chancellor">Hon'ble Chancellor</Link>
                </li>

                <li>
                  <Link to="/honorable-vice-chancellor">
                    Hon'ble Vice-Chancellor
                  </Link>
                </li>
                <li>
                  <Link to="/official-registar">Registrar</Link>
                </li>

                <li>
                  <Link to="/governing-body">Governing Body</Link>
                </li>
                <li>
                  <Link to="/board-management">Board of Management</Link>
                </li>
                <li>
                  <Link to="/academic-council">Academic Council</Link>
                </li>
                <li>
                  <Link to="/board-advisor">Board of Advisors</Link>
                </li>
                <li>
                  <Link to="/other-communitie">Other Committees</Link>
                </li>
                <li>
                  <Link to="/message">Messages of the Dignitaries</Link>
                </li>
                <li>
                  <Link to="/statues-and-ordinance">
                    Statutes and Ordinances
                  </Link>
                </li>
                <li>
                  <Link to="/recognisation">Recognitions and Approvals</Link>
                </li>
                <li>
                  <Link to="/awards">Awards</Link>
                </li>
                <li>
                  <Link to="/media-coverage">Media Coverage</Link>
                </li>
                <li>
                  <Link to="/RTI">RTI</Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-faculty">
                    Code of Conduct (Faculty)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-management">
                    Code of Conduct (Management)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-student">
                    Code of Conduct (Student)
                  </Link>
                </li>
                <li>
                  <Link to="/code-of-conduct-boardes-of-hostel">
                    Code of Conduct (Boardes of Hostel)
                  </Link>
                </li>
              </ul>
            </Col>

            {/* Column 2: Schools */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">Our Schools</h4>
              <div className="schools-grid">
                {schools.map((school) => (
                  <div key={school.id} className="school-item">
                    <Link to={`/school-details/${school.name}`}>{school.title}</Link>
                  </div>
                ))}
              </div>
            </Col>

            {/* Column 3: Admissions & Academics */}
            <Col md={3} className="footer-column">
              <h4 className="footer-heading">Admissions</h4>
              <ul className="footer-links">
                <li><Link to="/programmes-and-eligibilities">Programmes and Eligibilities</Link></li>
                <li><Link to="/programmes-by-qualification">Programmes By Qualification</Link></li>
                <li><Link to="/apply-online">Apply Online</Link></li>
                <li><Link to="/admission-procedure-guidelines">Admission Procedure</Link></li>
                <li><Link to="/pay-fees-online">Online Payment</Link></li>
                <li><Link to="/admission-help-desk">Admission Helpdesk</Link></li>
              </ul>

              <h4 className="footer-heading mt-4">Academics</h4>
              <ul className="footer-links">
                <li><Link to="/academic-philosophy">Academic Philosophy</Link></li>
                <li><Link to="/academic-partner">Academic Partners</Link></li>
                <li><Link to="/teaching-methodology-pedagogy">Teaching Methodology</Link></li>
                <li><Link to="/mooc-with-isbm">MOOC with ISBM</Link></li>
                <li><Link to="/Research">Research</Link></li>
              </ul>
            </Col>

            {/* Column 4: Logo, Address, Map & Social */}
            <Col md={3} className="footer-contact-column">
              <div className="footer-logo-wrapper">
                <img
                  src={logoWhite}
                  alt="ISBM University Logo"
                  className="footer-logo"
                />
              </div>

              <div className="footer-address">
                <strong>ISBM University</strong><br />
                Village & Post - Nawapara (Kosamkot)<br />
                Block - Dongargarh, Distt - Rajnandgaon<br />
                Chhattisgarh - 491445, India
              </div>

              <div className="footer-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4049.1388814933766!2d82.27918607519366!3d20.843678994109872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a25febf2368cb33%3A0x8df9cf351c0cd8d5!2sISBM%20University!5e1!3m2!1sen!2sin!4v1752229578743!5m2!1sen!2sin"
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="ISBM University Location"
                ></iframe>
              </div>

              <div className="footer-social-icons">
                <div className="social-icons-grid">
                  <a href="https://www.facebook.com/isbmuniversity/" aria-label="Facebook" className="social-icon">
                    <img src={facebook} alt="Facebook" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a href="https://instagram.com/isbm_university" aria-label="Instagram" className="social-icon">
                    <img src={instagram} alt="Instagram" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a href="https://twitter.com/ISBMUniversity" aria-label="Twitter" className="social-icon">
                    <img src={twitter} alt="Twitter" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a href="https://www.linkedin.com/school/13211303/admin/" aria-label="LinkedIn" className="social-icon">
                    <img src={linkedin} alt="LinkedIn" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                  <a href="https://www.youtube.com/c/ISBMUniversity" aria-label="YouTube" className="social-icon">
                    <img src={youtube} alt="YouTube" className="icon-img" />
                    <span className="icon-bg"></span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-copyright">
        <Container>
          <Row>
            <Col className="text-center">
              <p className="fw-medium">
                © Copyright {new Date().getFullYear()}{" "}
                <a href="https://isbmuniversity.edu.in/">ISBM University</a>
                . All Rights Reserved
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;